import { render, staticRenderFns } from "./TeacherPerformance.vue?vue&type=template&id=7eca6d0c&scoped=true&"
import script from "./TeacherPerformance.vue?vue&type=script&lang=js&"
export * from "./TeacherPerformance.vue?vue&type=script&lang=js&"
import style0 from "./TeacherPerformance.vue?vue&type=style&index=0&id=7eca6d0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca6d0c",
  null
  
)

export default component.exports